module.exports = __webpack_public_path__ + "images/mitsubishi420268b2f9e1758da7be31e22964922a.png";